// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"e4088fd7","453":"b9c46ee6","726":"ac7dd173"}[chunkId] + ".chunk.js";
};